// extracted by mini-css-extract-plugin
export default {"imgs_video":"ImgVideo_imgs_video__QGQL8"};